/* TEST-007 — P02 PDP Top Copy router. TEST_MODE='live' default. */
(function(){
  'use strict';
  var TEST_ID='pdp_p02_top_copy', COOKIE='cro_pdp_p02_top_copy_v1', PARAM='cl_copy_v', TTL=30;
  var SPLIT=[{a:'control',w:30},{a:'b',w:70}]; // 2026-05-26 rev2 — narrowed to b (sig winner +49.9%, p=0.009)
  var VALID={control:1,b:1}; // 2026-05-26 rev2 — kill a, d (existing cookies for those re-bucket via validLabels check)
  var TEST_MODE='live'; // flip to 'live' to start traffic split
  // ─── Metafield override (rev2.5 — Wiki/Ecomm/Reports/cro-weekly-2026-05-26 §arch) ───
  // Read shop.metafields.cro.test_config['pdp_p02_top_copy'] from the page-global
  // emitted by snippets/cro-config-global.liquid. If present, REPLACE the
  // hardcoded SPLIT + VALID below so weight changes via Scripts/cro_config.py
  // take effect on next page load without a theme deploy.
  // Falls back to the hardcoded defaults if the global is missing (dev/preview).
  try {
    var __mf = window.STIX_CRO_CONFIG && window.STIX_CRO_CONFIG[TEST_ID];
    if (__mf && __mf.variants && __mf.variants.length) {
      SPLIT = __mf.variants.map(function(v){ return {a: v.label, w: v.weight}; });
      VALID = {};
      __mf.variants.forEach(function(v){ VALID[v.label] = 1; });
      if (__mf.status === 'paused' || __mf.status === 'reverted') TEST_MODE = 'smoke';
      window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
      window.STIX_TEST_SOURCE[TEST_ID] = 'metafield';
    } else {
      window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
      window.STIX_TEST_SOURCE[TEST_ID] = 'hardcoded-fallback';
    }
  } catch (e) {
    window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
    window.STIX_TEST_SOURCE[TEST_ID] = 'hardcoded-fallback-error';
  }

  function gc(n){var m=document.cookie.match(new RegExp('(?:^|;\\s*)'+n+'=([^;]*)'));return m?decodeURIComponent(m[1]):null;}
  function sc(n,v,d){var x=new Date();x.setTime(x.getTime()+d*86400000);document.cookie=n+'='+encodeURIComponent(v)+'; expires='+x.toUTCString()+'; path=/; SameSite=Lax';}
  function ovr(){try{var p=new URLSearchParams(location.search).get(PARAM);if(!p) return null; p=p.toLowerCase(); return VALID[p]?p:null;}catch(e){return null;}}
  function pick(){var r=Math.random()*100,c=0;for(var i=0;i<SPLIT.length;i++){c+=SPLIT[i].w;if(r<c)return SPLIT[i].a;}return SPLIT[0].a;}
  function isBot(){return /bot|crawl|spider|slurp|duckduckbot|baiduspider|yandex|bingpreview|facebookexternalhit|embedly|lighthouse|headlesschrome/i.test(navigator.userAgent||'');}
  function init(){
    var root=document.querySelector('[data-cl-copy-router]');
    if(!root) return;
    var arm=ovr(), fromUrl=!!arm;
    if(!arm){
      if(TEST_MODE==='smoke') arm='control';
      else if(isBot()) arm='control';
      else{arm=gc(COOKIE); if(!arm||!VALID[arm]){arm=pick(); sc(COOKIE,arm,TTL);}}
    } else { sc(COOKIE,arm,TTL); }
    root.setAttribute('data-cl-active-arm',arm);
    window.STIX_TEST=window.STIX_TEST||{}; window.STIX_TEST[TEST_ID]=arm;
    if (typeof window.stixCroExpose === "function") { window.stixCroExpose(TEST_ID, arm, { page_type: "pdp" }); }

    // Inject the active variant's HTML into the existing buy-box element
    // (rendered from custom.short_description -> metafield-rich_text_field).
    // Caches the original innerHTML so toggling arms via URL restores cleanly.
    function replaceTarget(){
      var target = document.querySelector('.product__short-description .metafield-rich_text_field')
                || document.querySelector('.product__short-description')
                || document.querySelector('.metafield-rich_text_field');
      if(!target) return false;
      if(!target.hasAttribute('data-cl-copy-orig')){
        target.setAttribute('data-cl-copy-orig', target.innerHTML);
      }
      if(arm==='control'){
        target.innerHTML = target.getAttribute('data-cl-copy-orig');
        return true;
      }
      var src = root.querySelector('[data-cl-arm="'+arm+'"]');
      if(!src) return false;
      target.innerHTML = src.innerHTML;
      return true;
    }
    if(!replaceTarget()){
      var tries=0, iv=setInterval(function(){ tries++; if(replaceTarget()||tries>40) clearInterval(iv); },120);
    }

    var track=(new URLSearchParams(location.search).get('cl_copy_track')==='1');
    if(TEST_MODE==='live'||(fromUrl&&track)) fire(arm);
  }
    function fire(arm){
      // Delegates to the shared helper which handles:
      //   - cro_test_<id>=<arm> cart attribute
      //   - dataLayer.push (unconditional)
      //   - gtag('event','ab_test_exposure') with 5s retry
      //   - stix.track.exposeTest (Klaviyo + TW)
      // Helper is idempotent per (testId, arm), so safe to invoke twice
      // (once right after assignment, once from the legacy call site).
      if (typeof window.stixCroExpose === 'function') {
        window.stixCroExpose(TEST_ID, arm, { page_type: 'pdp' });
        return;
      }
      // Inline fallback if stix-cro-expose.js failed to load.
      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'ab_test_exposure', cl_test_id: TEST_ID, cl_test_variant: arm,
          page_type: 'pdp', page_path: location.pathname
        });
      } catch (e) {}
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'attributes[cro_test_' + TEST_ID + ']=' + encodeURIComponent(arm),
          credentials: 'same-origin', keepalive: true
        }).catch(function(){});
      } catch (e) {}
    }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
